import { useQuery } from '@tanstack/react-query';

import { subscriptionsQueries } from '../../subscriptions/data';
import { getLicences } from '../api';

export const useGetLicences = (
  companyID: string,
  options?: { enabled?: boolean },
) => {
  return useQuery({
    queryKey: [...subscriptionsQueries.getLicences, companyID],
    queryFn: () => getLicences(companyID),
    staleTime: 5000,
    enabled: options?.enabled ?? true,
  });
};
